import { FarsiKeyboardInput } from '../../shared/FarsiKeyboardInput';

export interface EssayAnswerInputProps {
  value: string;
  onChange: (value: string) => void;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  /** Learner answer writing direction (from question puzzleAlignment). */
  textDirection?: 'ltr' | 'rtl';
}

export function EssayAnswerInput({
  value,
  onChange,
  minLength,
  maxLength,
  disabled,
  placeholder,
  className,
  textDirection = 'rtl',
}: EssayAnswerInputProps) {
  const len = value.length;
  const showCount = minLength != null || maxLength != null;
  const belowMin = minLength != null && len < minLength;
  const aboveMax = maxLength != null && len > maxLength;
  const dir = textDirection === 'ltr' ? 'ltr' : 'rtl';

  return (
    <div className={className ?? 'space-y-1.5'}>
      <FarsiKeyboardInput
        multiline
        rows={6}
        keyboardPosition="fixed-bottom"
        value={value}
        onChange={(next) => {
          if (maxLength != null && next.length > maxLength) {
            onChange(next.slice(0, maxLength));
            return;
          }
          onChange(next);
        }}
        disabled={disabled}
        dir={dir}
        maxLength={maxLength}
        placeholder={placeholder}
        style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}
        className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 disabled:opacity-60"
      />
      {showCount ? (
        <p
          className={`text-xs ${
            belowMin || aboveMax
              ? 'text-amber-700 dark:text-amber-300'
              : 'text-gray-500 dark:text-gray-400'
          }`}
        >
          {len}
          {minLength != null ? ` / min ${minLength}` : ''}
          {maxLength != null ? ` (max ${maxLength})` : ''}
        </p>
      ) : null}
    </div>
  );
}
